<template>
<div>
    
<b-card no-body class="marginal" style="margin-top:0px; margin-bottom:20px">
  <b-card-header header-bg-variant="msstream" header-text-variant="white" class="text-center">
    <h6 style="margin:0px">{{$ml.get('linknewcollection')}}</h6>
  </b-card-header>
  <b-card-body style="font-size:small" size="sm">
    <b-form @submit.prevent="onSubmit()">
      <div class="border-error" v-if="error_" show>{{error_}}</div>
      <b-form-group id="vodGroup1"
                  label=""
                  label-for="vodInput1">
        <b-input-group style="font-size:small" size="sm" :prepend="$ml.get('config2')">
          <b-form-select v-model="collectionSelected" :options="collectionOptions" style="border:1px solid #2a5d77;"></b-form-select>
          <b-input-group-append>
              <b-button size="sm" variant="db-sbg" @click="addCollection()"><b-icon icon="plus"></b-icon></b-button>
          </b-input-group-append>
        </b-input-group>
      </b-form-group>
      <b-row class="justify-content-center">
        <p style="font-size: 11px" v-html="$ml.get('linkadd')"></p>
      </b-row>
      <b-row >
        <b-col cols="auto" v-for="(newcoll, newcollIdx) in collectionsToAdd" v-bind:key="newcollIdx">
          <div class="tag-not-selected " size="sm" @click="removeCollection(newcollIdx)"><b-icon icon="plus"></b-icon>&nbsp;{{newcoll}}</div>
        </b-col>
      </b-row>
      <b-row class="justify-content-center mt-2">
        <b-col cols="auto">
          <b-button size="sm" type="submit" variant="msstreamblue">
          <b-icon icon="check2-square" />
          {{$ml.get('confsubmit')}}
          </b-button>
        </b-col>
      </b-row>
    </b-form> 
  </b-card-body>
</b-card>
</div>
</template>

<script>
import VideoService from "@/services/video.service";
var videoService = new VideoService();
export default {
  name: "LinkCollection",
  props: [
    "video",
    "collections"
  ],
  data: function () {
    return {
      clientView: this.$auth.getMyUser().roles.indexOf("admin") > -1
        ? this.$auth.getMyClientView() || this.$auth.getMyUser().client
        : this.$auth.getMyUser().client,
      name: "",
      error_: "",
      collectionSelected: null,
      collectionOptions: [],
      collectionsToAdd: []
    };
  },
  mounted: function () {
    console.log("Link collection", this.video, this.collections);
    this.collections.forEach(elem => {
        if (this.video.collections && this.video.collections.findIndex(x => x === elem.name) > -1) {

        } else {
            this.collectionOptions.push({value: elem, text: elem.name});
        }
    })
    if (this.collectionOptions.length > 0) {
        this.collectionSelected = this.collectionOptions[0].value;
    }
  },
  methods: {
    onSubmit: function () {
        this.error_ = "";
        let newCollections = this.video.collections || [];
        newCollections.push(...this.collectionsToAdd);
         videoService.putVideoPluginById({collections: newCollections}, this.video._id, this.$auth.token())
        .then(() => {
            console.log("Collection linked");
            this.$emit('closeModal', true);
        }).catch(err => {
            this.error_ = this.$ml.get("errorlinkcollection");
        })
    },
    addCollection() {
        if (this.collectionsToAdd.findIndex(x => x === this.collectionSelected.name) === -1) {
            this.collectionsToAdd.push(this.collectionSelected.name);
        }
    },
    removeCollection(idx) {
        this.collectionsToAdd.splice(idx, 1);
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.border-error {
  border: 1px solid #ba0000;
  border-radius: 10px;
  background-color: rgba(#ba0000, 0.2);
  color: #ba0000;
  padding: 10px;
  margin-bottom: 15px;
}

.tag-not-selected {
  display: inline-block; 
  cursor: pointer;
  font-size: 12px;
  border: 1px solid #2a5d77 !important;
  border-radius: 8px;
  min-width: 50px;
  max-width: 170px;
  text-overflow: ellipsis; 
  overflow: hidden; 
  white-space: nowrap;
  align-items: center;
  text-align: center;
  margin-right: 3px;
  padding: 3px;
  padding-left: 10px; 
  padding-right: 10px;
  background-color: #2a5d77;
  color: white;
  box-shadow: rgba(#0f182f, 0.117647) 1px 3px 7px, rgba(#0f182f, 0.117647) 1px 3px 7px;
  &:hover {
    color: #2a5d77 !important;
    background-color: white !important;
  }
  
}

</style>
